/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  UniswapV3PriceProvider,
  UniswapV3PriceProviderInterface,
} from "../UniswapV3PriceProvider";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "_priceProvidersRepository",
        type: "address",
      },
      {
        internalType: "contract IUniswapV3Factory",
        name: "_factory",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint32",
            name: "periodForAvgPrice",
            type: "uint32",
          },
          {
            internalType: "uint8",
            name: "blockTime",
            type: "uint8",
          },
        ],
        internalType: "struct UniswapV3PriceProvider.PriceCalculationData",
        name: "_priceCalculationData",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "blockTime",
        type: "uint8",
      },
    ],
    name: "NewBlockTime",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint32",
        name: "period",
        type: "uint32",
      },
    ],
    name: "NewPeriod",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newPendingOwner",
        type: "address",
      },
    ],
    name: "OwnershipPending",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "contract IUniswapV3Pool",
        name: "pool",
        type: "address",
      },
    ],
    name: "PoolForAsset",
    type: "event",
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IUniswapV3Pool",
        name: "_pool",
        type: "address",
      },
    ],
    name: "adjustOracleCardinality",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "assetOldestTimestamp",
    outputs: [
      {
        internalType: "uint32",
        name: "oldestTimestamp",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "assetSupported",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "_blockTime",
        type: "uint8",
      },
    ],
    name: "changeBlockTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_period",
        type: "uint32",
      },
    ],
    name: "changePeriodForAvgPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IUniswapV3Pool",
        name: "_pool",
        type: "address",
      },
    ],
    name: "observationsStatus",
    outputs: [
      {
        internalType: "bool",
        name: "bufferFull",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "enoughObservations",
        type: "bool",
      },
      {
        internalType: "uint16",
        name: "currentCardinality",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "pools",
    outputs: [
      {
        internalType: "contract IUniswapV3Pool",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceCalculationData",
    outputs: [
      {
        internalType: "uint32",
        name: "periodForAvgPrice",
        type: "uint32",
      },
      {
        internalType: "uint8",
        name: "blockTime",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProviderPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProvidersRepository",
    outputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IUniswapV3Pool",
        name: "_pool",
        type: "address",
      },
    ],
    name: "quotePrice",
    outputs: [
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quoteToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "removePendingOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IUniswapV3Pool",
        name: "_pool",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "_currentObservationIndex",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "_currentObservationCardinality",
        type: "uint16",
      },
    ],
    name: "resolveOldestObservationTimestamp",
    outputs: [
      {
        internalType: "uint32",
        name: "oldestTimestamp",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "contract IUniswapV3Pool",
        name: "_pool",
        type: "address",
      },
    ],
    name: "setupAsset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newPendingOwner",
        type: "address",
      },
    ],
    name: "transferPendingOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "uniswapV3Factory",
    outputs: [
      {
        internalType: "contract IUniswapV3Factory",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "contract IUniswapV3Pool",
        name: "_pool",
        type: "address",
      },
    ],
    name: "verifyPool",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type UniswapV3PriceProviderConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: UniswapV3PriceProviderConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class UniswapV3PriceProvider__factory extends ContractFactory {
  constructor(...args: UniswapV3PriceProviderConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "UniswapV3PriceProvider";
  }

  deploy(
    _priceProvidersRepository: string,
    _factory: string,
    _priceCalculationData: UniswapV3PriceProvider.PriceCalculationDataStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<UniswapV3PriceProvider> {
    return super.deploy(
      _priceProvidersRepository,
      _factory,
      _priceCalculationData,
      overrides || {}
    ) as Promise<UniswapV3PriceProvider>;
  }
  getDeployTransaction(
    _priceProvidersRepository: string,
    _factory: string,
    _priceCalculationData: UniswapV3PriceProvider.PriceCalculationDataStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _priceProvidersRepository,
      _factory,
      _priceCalculationData,
      overrides || {}
    );
  }
  attach(address: string): UniswapV3PriceProvider {
    return super.attach(address) as UniswapV3PriceProvider;
  }
  connect(signer: Signer): UniswapV3PriceProvider__factory {
    return super.connect(signer) as UniswapV3PriceProvider__factory;
  }
  static readonly contractName: "UniswapV3PriceProvider";
  public readonly contractName: "UniswapV3PriceProvider";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): UniswapV3PriceProviderInterface {
    return new utils.Interface(_abi) as UniswapV3PriceProviderInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): UniswapV3PriceProvider {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as UniswapV3PriceProvider;
  }
}
